import { useAtom } from "jotai";
import { useQuery } from "@tanstack/react-query";
import { mbxUserAtom } from "../../atoms/atoms";
import { execReadBySortkey } from "../../modules/DBService";

const serviceTypeByCompany = /* GraphQL */ `
    query ServiceTypeByCompany(
        $companyId: String
        $categoryNameName: ModelServiceTypeByCompanySortedByCategoryNameNameCompositeKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelServiceTypeFilterInput
        $limit: Int
        $nextToken: String
    ) {
        serviceTypeByCompany(
            companyId: $companyId
            categoryNameName: $categoryNameName
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                name
                desc
                categoryId
                categoryName
                minutes
                price
                active
                deleted
            }
            nextToken
        }
    }
`;
export function useServices() {
    const [mbxUser] = useAtom(mbxUserAtom);

    return useQuery({
        queryKey: ["analysis-all-services"],
        queryFn: async () => {
            try {
                const { items: services } = await execReadBySortkey({
                    opname: "serviceTypeByCompany",
                    op: serviceTypeByCompany,
                    id: {
                        companyId: mbxUser.companyId
                    },
                    filter: {
                        and: [
                            { active: { ne: false } },
                            { deleted: { ne: true } },
                            { isVisible: { ne: false } }
                        ]
                    },
                    limit: 200
                });
                return services;
            } catch (e) {
                console.log("error bookings-bks", e);
            }
        }
    });
}
